<template>
  <section class="main-section p-2 my-5 col-10 offset-1">

    <!-- User Registration Form -->
    <div class="text-center my-4">
      <h2 v-if="excType == 1" class="text-primary">استعراض طلب التمديد</h2>
      <h2 v-else class="text-primary">استعراض طلب الإسقاط</h2>
    </div>
    <div class="row mx-0">
      <!-- Applicant Details -->
      <div class="col col-lg-10 offset-lg-1 col-12">
        <div class="table-responsive">
          <table class="main-table more-info table table-bordered">
            <thead>
              <tr class="">
                <td class="text-end">
                  بيانات
                </td>
                <td class="text-start">
                  الطلب
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>الاسم:</strong>
                </td>
                <td><b>
                    {{ except.applicantName }}
                  </b></td>
              </tr>
              <tr>
                <td>
                  <strong>رقم الجواز:</strong>
                </td>
                <td>
                  {{ except.passNo }}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>تاريخ تقديم الطلب </strong>
                </td>
                <td>
                  {{ except.applyDate }}
                </td>
              </tr>
              <tr v-if="excType == 1">
                <td>
                  <strong>تمديد إلى تاريخ:</strong>
                </td>
                <td>
                  {{ except?.newExpDate }}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>ملاحظة المتقدم</strong>
                </td>
                <td>
                  {{ except.appNote }}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>الإجراء</strong>
                </td>
                <td :class="'text-' + excStatusClass[except.status]">
                  {{ excStatusText[except.status] }}
                </td>
              </tr>
              <tr v-if="except.status != 1">
                <td>
                  <strong>{{ excStatusText[except.status] }} ب:</strong>
                </td>
                <td>
                  {{ except?.actionBy }}
                </td>
              </tr>
              <tr v-if="except.status != 1">
                <td>
                  <strong>اتخذ الإجراء بتاريخ : </strong>
                </td>
                <td>
                  {{ except?.actionDate }}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>ملاحظة المسؤول</strong>
                </td>
                <td>
                  {{ except.empNote }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- Documents Section -->
      <div class="my-3">
        <h4 class="text-center text-white text-shadow">المستندات المرفقة</h4>
        <div class="row row-cols-xl-4 row-cols-md-2 row-cols-1 justify-content-center">
          <div class="col my-2" v-for="(doc, index) in except.docs" :key="index">
            <div class="card shadow-sm rounded-lg">
              <div class="image-container">
                <a :href="`${doc.docPath}`" target="_blank" class="" :title="'افتح الصورة'">
                  <img :src="`${doc.docPath}`" class="card-img-top doc-thumbnail" :alt="doc.docType" />
                </a>
              </div>
              <div class="card-body p-3">
                <h6 class="card-title text-center">{{ doc.docType }}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between my-3">
        <div class="col-md-3 col-4 ">
          <div class="w-100">
            <button @click="$router.go(-1)" class="btn btn-secondary col-11" type="button">
              عودة <font-awesome-icon icon="fa-regular fa-circle-left" />
            </button>
          </div>
        </div>
        <div v-if="except.status == 1" class=" d-flex col-md-6  col-8">
          <div class="w-100 ">
            <button id="submit-btn" @click="action = 0 ; actModalTitle = 'رفض طلب التمديد'" data-bs-toggle="modal" data-bs-target="#ext-action" type="button" class="btn btn-danger col-11"
              :disabled="!getUser?.privs.includes('extention')">
              رفض
            </button>
          </div>
          <div class="w-100 ">
            <button id="submit-btn" @click="action = 1 ; actModalTitle = 'الموافقة على طلب التمديد'" data-bs-toggle="modal" data-bs-target="#ext-action" type="button" class="btn btn-success col-11"
              :disabled="!getUser?.privs.includes('extention')">
              موافقة
            </button>
          </div>
        </div>
      </div>
    </div>

  </section>

  <GeneralModal :modalTitle="actModalTitle" :modalId="'ext-action'" :modalFormLabel="'اكتب السبب'"
    :inputFields="actModalFields" :modalSubmitFnc="'submitForm'" :submitParam="action" />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import GeneralModal from "@/components/Modal.vue";
import router from '@/router';
export default {
  props: {
    formLabel: String,
    formFields: Object,
  },
  data() {
    return {
      excType: this.$route.params?.type, // 1=>extend , 2 => drop
      except: {},
      formFields: {
        id: { id: 'extendId', label: '', type: 'hidden', value: this.$route.params?.id },
        note: { id: 'note', label: 'ملاحظات', type: 'text', value: "" },
      },
      excStatusText: [
        'تم الرفض',
        'في انتظار الإجراء',
        'تمت الموفقة',
      ],
      excStatusClass: [
        'danger',
        'secondary',
        'success',
      ],
      actModalFields:[
        {
          id: "empNote",
          type: "text",
          placeholder: "(اختياري)",
          model: "empNote",
          value: "",
          required: false,
        }
      ],
      action: null,
      actModalTitle: '',


      alert: null, // Object to hold alert messages
    };
  },

  /** */
  async created() {
    await this.fetchAllOptions();
  },
  /** */
  computed: {
    ...mapGetters(['getDeparts', 'getUser'])
  },
  /** */
  components: {
    GeneralModal
  },
  /** */
  methods: {
    /** */
    ...mapActions([
      'fetchDeparts',
      'fetchUser',
    ]),
    /********************************/

    /** */
    async fetchAllOptions() {

      if (this.getDeparts.length == 0) {
        await this.fetchDeparts();
      }
      if (this.getUser.hasOwnProperty("empNo") == 0) {
        await this.fetchUser();
      }
      //
      try {
        const response = await this.$axios.post("api/employee/except/getexceptbyid", { id: this.$route.params?.id, excType: this.excType });
        if (response?.data.isSuccess) {
          this.except = response.data.except;
        } else {
          this.$tempAlert(response?.data.msg, 'warning');
        }
      } catch (error) {
        if (error.response?.data) {
          this.$tempAlert(error.response.data.msg ?? "مشكلة في الاتصال بالخادم", 'danger');
        }
        console.error("Error fetching options:", error);
      }

    },
    /***********************/

    // Form submission method
    async submitForm(action) {
      const actionText = ['تم رفض الطلب', 'تمت الموافقة على الطلب'];
      const actionClass = ['danger', 'success'];
      const formData = new FormData();
      // const reqData ={}
      formData.append('action', action);
      this.formFields.note.value = this.actModalFields[0].value
      Object.keys(this.formFields).forEach((key) => {
        formData.append(key, this.formFields[key].value);
      });

      try {
        const response = await this.$axios.post("api/employee/except/response", formData);
        if (response.data.isSuccess) {
          this.$tempAlert(actionText[action], actionClass[action]);
          setTimeout(() => {
            this.$router.push({ name: "AdminApplicantSearch" });
          }, 1000)
        } else {
          this.$tempAlert(response.data.msg ?? "فشل العملية");
        }
      } catch (error) {
        if (error.response?.data) {
          this.$tempAlert(error.response.data.msg, 'warning');
          var emsg = {
            msg: "",
            interval: 4000
          };
          error.response.data?.errors.forEach((e) => {
            emsg.msg += e + "<br/>";
            emsg.interval += 2000;
          })
          setTimeout(() => {
            this.$tempAlert(emsg.msg, 'warning', emsg.interval);
          }, 1000)
        }
        console.error("Submission error:", error);
      }
    },

  },
};
</script>

<style scoped>
.form-container {
  max-width: 800px;
  margin: 0 auto;
}

.alert {
  margin-top: 20px;
}

.btn {
  padding: 12px;
  font-size: 16px;
}
</style>